// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rl-6";
export var imgContainer = "_rl-3";
export var menuIcon = "_rl-5";
export var pillWrapper = "_rl-2";
export var pillsContainer = "_rl-1";
export var subscriptionCard = "_rl-0";
export var subscriptionLogo = "_rl-4";